<template>
  <div class="smart-input smart-input_image">
    <div v-if="caption" class="smart-input__name">
      {{ caption }}
    </div>

    <input
        ref="fileInput"
        type="file"
        style="display:none"
        accept="image/*"
        onclick="this.value=null"
        @change="addImage"
    >

    <img v-show="!deleteAfterLoad && newValue" alt="" :src="newValue">
    <div v-if="error" class="smart-input__error-message">
      {{ error }}
    </div>
    <CamsButton
        priority="primary"
        type="button"
        :size="size"
        @click="$refs.fileInput.click()"
    >
      Загрузить фото
    </CamsButton>
  </div>
</template>

<script>
/**
 * Компонент для загрузки изображений.
 */
export default {
  name: "SmartInputImage",
  props: {
    /**
     * Значение, которое передается через v-model.
     */
    value: {
      type: String,
      default: "",
    },
    /**
     * Вариант размера кнопки.
     *
     * @values s, m, l.
     */
    size: {
      type: String,
      default: "m",
    },
    /**
     * Заголовок изображения.
     */
    caption: {
      type: String,
      default: "",
    },
    /**
     * Текст ошибки для поля.
     */
    error: {
      type: String,
      default: "",
    },
    /**
     * Флаг для очищения инпута после загрузки изорбражения.
     * При false загружаемое изображение отобразится для просмотра.
     */
    deleteAfterLoad: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newValue: this.value,
      image: null,
    };
  },
  watch: {
    /**
     * Наблюдение за оригинальным значением для его синхронизации со внутренним значением компонента и отправкой события `@change`.
     *
     * @param {String} val
     */
    value(val) {
      if (this.newValue === val) {
        return;
      }
      this.newValue = val;
      /**
       * Срабатывает при изменении значения со стороны родительского компонента.
       * @event change
       */
      this.$emit("change", val);
    },
  },
  methods: {
    /**
     * Метод для добавления изображений. deleteAfterLoad маркер того что изображение не покажется после загрузки.
     *
     * @param {Event} event
     */
    addImage(event) {
      const file = event.target.files[0];
      this.image = URL.createObjectURL(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        this.newValue = reader.result;
        this.$emit("input", this.newValue);
        if (this.deleteAfterLoad === true) {
          this.newValue = null;
        }
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>
